import { render, staticRenderFns } from "./ModificationsTab.vue?vue&type=template&id=5a823952"
import script from "./ModificationsTab.js?vue&type=script&lang=js&external"
export * from "./ModificationsTab.js?vue&type=script&lang=js&external"
import style0 from "./ModificationsTab.vue?vue&type=style&index=0&id=5a823952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports